
// app/javascript/controllers/contentcategories_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["relevanceSelect", "contentCategorySelect"]
    static values = { placeholder: String }

    relevanceChanged() {
        const relevance = this.relevanceSelectTarget.value

        fetch(`/contentcategories/filtered?relevance=${encodeURIComponent(relevance)}`)
            .then(response => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`)
                return response.json()
            })
            .then(data => {
                this.contentCategorySelectTarget.innerHTML = ""
                const placeholder = document.createElement("option")
                placeholder.textContent = this.placeholderValue
                placeholder.value = ""
                this.contentCategorySelectTarget.appendChild(placeholder)

                data.forEach(category => {
                    const option = document.createElement("option")
                    option.value = category.id
                    option.textContent = category.name
                    this.contentCategorySelectTarget.appendChild(option)
                })
            })
            .catch(error => {
                console.error("Error loading content categories:", error)
            })
    }
}
